import React, { useEffect, useState, useMemo } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { useCart } from "../context/CartContext";
import "../styles/ShopProducts.css";

export default function ShopProducts() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const [premiumShopIds, setPremiumShopIds] = useState(new Set());

  const [search, setSearch] = useState("");

  const { cart, addToCart, updateQty } = useCart();

  useEffect(() => {
  const unsubscribe = onSnapshot(
    collection(db, "shops"),
    (snapshot) => {
      const premiumIds = new Set();

      snapshot.docs.forEach((doc) => {
        const data = doc.data();

        const shopType =
          data["Type (Premium/Normal)"] ||
          data.Type ||
          "Normal";

        if (
          String(shopType)
            .toLowerCase()
            .includes("premium")
        ) {
          premiumIds.add(doc.id);
        }
      });

      setPremiumShopIds(premiumIds);
    },
    (err) => {
      console.error(
        "Failed to load shop types:",
        err
      );
    }
  );

  return unsubscribe;
}, []);

  useEffect(() => {
  const unsubscribe = onSnapshot(
    collection(db, "shopproducts"),
    (snapshot) => {
      const list = snapshot.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        .filter((p) => p.active !== false);

      setProducts(list);
      setLoading(false);
    },
    (err) => {
      console.error(err);
      setLoading(false);
    }
  );

  return unsubscribe;
}, []);

  const filteredProducts = useMemo(() => {
  return products
    .filter(
      (item) =>
        item.shopId &&
        premiumShopIds.has(item.shopId)
    )
    .filter(
      (item) =>
        item.name
          ?.toLowerCase()
          .includes(search.toLowerCase()) ||
        item.shopName
          ?.toLowerCase()
          .includes(search.toLowerCase()) ||
        item.category
          ?.toLowerCase()
          .includes(search.toLowerCase())
    );
}, [products, premiumShopIds, search]);

  const getCartItem = (productId) =>
    cart.find(
      (item) =>
        item.type === "shop" &&
        (item.id === productId || item.product_id === productId)
    );

  if (loading) {
    return (
      <div className="shop-products-loading">
        Loading...
      </div>
    );
  }

  return (
    <div className="shop-products-page">
      <h2 className="shop-products-title">
        All Shop Products
      </h2>

      <input
  className="shop-products-search"
  type="text"
  placeholder="🔍 Search products..."
  value={search}
  onChange={(e) => setSearch(e.target.value)}
/>

      {filteredProducts.length === 0 ? (
        <div className="shop-products-empty">
          No products available.
        </div>
      ) : (
        <div className="shop-products-list">
          {filteredProducts.map((item) => {
            const cartItem = getCartItem(item.id);

            return (
              <div
                className="shop-product-card"
                key={item.id}
              >
                <img
                  className="shop-product-image"
                  src={
                    item.image ||
                    "https://via.placeholder.com/100"
                  }
                  alt={item.name}
                />

                <div className="shop-product-info">
                  <div className="shop-product-name">
                    {item.name}
                  </div>

                  {item.shopName && (
                    <div className="shop-product-shop">
                      🏪 {item.shopName}
                    </div>
                  )}

                  <div className="shop-product-stock">
                    Stock : {item.stock}
                  </div>

                  <div className="shop-product-price">
                    ₹{item.price}
                  </div>
                </div>

                <div className="shop-product-action">
                  {!cartItem ? (
                    <button
                      className="shop-add-btn"
                      disabled={item.stock <= 0}
                      onClick={() =>
                        addToCart({
                          type: "shop",
                          id: item.id,
                          shopId: item.shopId,
                          ownerUid: item.ownerUid,
                          shopName:
                            item.shopName || "",
                          name: item.name,
                          brand:
                            item.brand || "",
                          image:
                            item.image || "",
                          price: Number(
                            item.price
                          ),
                          mrp: Number(
                            item.mrp ||
                              item.price
                          ),
                          stock: Number(
                            item.stock
                          ),
                        })
                      }
                    >
                      {item.stock <= 0
                        ? "Out"
                        : "+ Add"}
                    </button>
                  ) : (
                    <div className="shop-qty-box">
                      <button
                        className="shop-qty-btn"
                        onClick={() =>
                          updateQty(
                            cartItem.key,
                            cartItem.qty - 1
                          )
                        }
                      >
                        −
                      </button>

                      <span className="shop-qty-text">
                        {cartItem.qty}
                      </span>

                      <button
                        className="shop-qty-btn"
                        onClick={() =>
                          updateQty(
                            cartItem.key,
                            cartItem.qty + 1
                          )
                        }
                      >
                        +
                      </button>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}